// Where to go after signing in: the page someone opened before being sent to sign in, such as a
// "finish connecting your store" link. Kept for this tab only.
const KEY = 'storage.returnTo';

export const rememberReturnTo = (path) => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage blocked: they land on the dashboard instead
  }
};

// Read without clearing: the sign-in page and the signed-out route both redirect, in either order
export const returnTo = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    // Only paths inside this app
    return path && path.startsWith('/') && !path.startsWith('//') ? path : '/';
  } catch {
    return '/';
  }
};

// Called once a signed-in page has opened
export const clearReturnTo = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
};
